import { StoreState } from "../../../store/store.interface";

export const getOrderReturnData = (state: StoreState) => state.returnState.orderReturn.data;
